export default __webpack_public_path__ + "static/ProValue_2-d3e5acdf3c9bd0b964ead980a52c0e40.webp";